export const BARD_SPELLS = [
  {
    level: 1,
    spells: [
      { id: 33, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x5' }, restricted: false },
      { id: 52, cost: 2, max: 2, frequency: null, restricted: false },
      { id: 56, cost: 2, max: 2, frequency: null, restricted: false },
      { id: 88, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 124, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 134, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 142, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
    ]
  },
  {
    level: 2,
    spells: [
      { id: 46, cost: 1, max: null, frequency: { amount: 2, per: 'Refresh', charge: null }, restricted: false },
      { id: 49, cost: 3, max: 1, frequency: null, restricted: false },
      { id: 76, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 86, cost: 1, max: 4, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 98, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 140, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
      { id: 147, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
    ]
  },
  {
    level: 3,
    spells: [
      { id: 20, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 15, cost: 1, max: 1, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 31, cost: 1, max: 4, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 58, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 51, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 143, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
    ]
  },
  {
    level: 4,
    spells: [
      { id: 5, cost: 1, max: 4, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 175, cost: 3, max: 1, frequency: null, restricted: false },
      { id: 126, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 136, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 141, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
      { id: 145, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
      { id: 156, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 159, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 161, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
  {
    level: 5,
    spells: [
      { id: 8, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 6, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 42, cost: 1, max: 1, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 50, cost: 3, max: 1, frequency: null, restricted: false },
      { id: 77, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 93, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 146, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
    ]
  },
  {
    level: 6,
    spells: [
      { id: 29, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 40, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 186, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 91, cost: 1, max: 1, frequency: null, restricted: false },
      { id: 135, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 144, cost: 1, max: 1, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x5' }, restricted: false },
      { id: 148, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
]

export const HEALER_SPELLS = [
  {
    level: 1,
    spells: [
      { id: 13, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 26, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 51, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 52, cost: 3, max: 2, frequency: null, restricted: false },
      { id: 56, cost: 2, max: 2, frequency: null, restricted: false },
      { id: 74, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 75, cost: 1, max: 1, frequency: { amount: null, per: null, charge: 'Unlimited' }, restricted: false },
      { id: 124, cost: 1, max: null, frequency: { amount: 2, per: 'Life', charge: 'Charge x3' }, restricted: false },
    ]
  },
  {
    level: 2,
    spells: [
      { id: 2, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 48, cost: 1, max: 4, frequency: { amount: 2, per: 'Balls', charge: 'Unlimited' }, restricted: false },
      { id: 176, cost: 3, max: 1, frequency: null, restricted: false },
      { id: 76, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 79, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: 'Charge x3' }, restricted: false },
      { id: 86, cost: 2, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 130, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: 'Charge x3' }, restricted: false },
      { id: 134, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 154, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: 'Charge x3' }, restricted: false },
    ]
  },
  {
    level: 3,
    spells: [
      { id: 3, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 12, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: 'Charge x3' }, restricted: false },
      { id: 50, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 58, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 69, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 82, cost: 1, max: 3, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 98, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 120, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 127, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x5' }, restricted: false },
    ]
  },
  {
    level: 4,
    spells: [
      { id: 25, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 28, cost: 1, max: 1, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x10' }, restricted: false },
      { id: 43, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 70, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 81, cost: 1, max: 2, frequency: { amount: 2, per: 'Refresh', charge: null }, restricted: false },
      { id: 119, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 159, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 160, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
    ]
  },
  {
    level: 5,
    spells: [
      { id: 1, cost: 1, max: 2, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 6, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 23, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 47, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 72, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 151, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 167, cost: 2, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
  {
    level: 6,
    spells: [
      { id: 7, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 96, cost: 1, max: 1, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 104, cost: 1, max: 1, frequency: null, restricted: false },
      { id: 105, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 108, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 114, cost: 1, max: 1, frequency: null, restricted: false },
      { id: 118, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 148, cost: 1, max: 4, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 171, cost: 2, max: 1, frequency: null, restricted: false },
    ]
  },
]

export const WIZARD_SPELLS = [
  {
    level: 1,
    spells: [
      { id: 13, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 52, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 56, cost: 2, max: 2, frequency: null, restricted: false },
      { id: 66, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 61, cost: 1, max: 8, frequency: { amount: 3, per: 'Balls', charge: 'Unlimited' }, restricted: false },
      { id: 78, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 98, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 134, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: 'Charge x3' }, restricted: false },
    ]
  },
  {
    level: 2,
    spells: [
      { id: 12, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 31, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 48, cost: 1, max: 3, frequency: { amount: 2, per: 'Balls', charge: 'Unlimited' }, restricted: false },
      { id: 86, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 110, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 124, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 158, cost: 1, max: 3, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 160, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
    ]
  },
  {
    level: 3,
    spells: [
      { id: 43, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x3' }, restricted: false },
      { id: 44, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 58, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 71, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 79, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 82, cost: 1, max: 3, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 92, cost: 1, max: 4, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 122, cost: 1, max: null, frequency: { amount: 2, per: 'Life', charge: null }, restricted: false },
      { id: 138, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 162, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
  {
    level: 4,
    spells: [
      { id: 41, cost: 1, max: null, frequency: { amount: 2, per: 'Refresh', charge: null }, restricted: false },
      { id: 38, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 60, cost: 1, max: 4, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 83, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 133, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 156, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 159, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 168, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 174, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x3' }, restricted: false },
    ]
  },
  {
    level: 5,
    spells: [
      { id: 6, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 34, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 175, cost: 4, max: 1, frequency: null, restricted: false },
      { id: 107, cost: 1, max: 4, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 115, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 151, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 169, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 170, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
  {
    level: 6,
    spells: [
      { id: 18, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 45, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 54, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 59, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 105, cost: 2, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 118, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 149, cost: 2, max: 1, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 172, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 173, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
]

export const DRUID_SPELLS = [
  {
    level: 1,
    spells: [
      { id: 14, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x10' }, restricted: false },
      { id: 48, cost: 1, max: 2, frequency: { amount: 2, per: 'Balls', charge: 'Unlimited' }, restricted: false },
      { id: 52, cost: 2, max: 2, frequency: null, restricted: false },
      { id: 56, cost: 2, max: 2, frequency: null, restricted: false },
      { id: 78, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: 'Charge x3' }, restricted: false },
      { id: 84, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 98, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
    ]
  },
  {
    level: 2,
    spells: [
      { id: 35, cost: 1, max: 1, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 51, cost: 4, max: 1, frequency: null, restricted: false },
      { id: 61, cost: 1, max: 2, frequency: { amount: 2, per: 'Balls', charge: 'Unlimited' }, restricted: false },
      { id: 63, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 75, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 86, cost: 1, max: 4, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 111, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 124, cost: 1, max: null, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 152, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: 'Charge x3' }, restricted: false },
    ]
  },
  {
    level: 3,
    spells: [
      { id: 17, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 179, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 43, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 58, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 64, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 71, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 83, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 123, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 153, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
  {
    level: 4,
    spells: [
      { id: 175, cost: 4, max: 1, frequency: null, restricted: false },
      { id: 65, cost: 2, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 67, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 68, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 82, cost: 1, max: 2, frequency: { amount: 1, per: 'Ball', charge: 'Unlimited' }, restricted: false },
      { id: 94, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 159, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 160, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
    ]
  },
  {
    level: 5,
    spells: [
      { id: 6, cost: 1, max: 2, frequency: { amount: 1, per: 'Life', charge: null }, restricted: false },
      { id: 177, cost: 5, max: 1, frequency: null, restricted: false },
      { id: 53, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 62, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 77, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 89, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 113, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 127, cost: 2, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 165, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
  {
    level: 6,
    spells: [
      { id: 19, cost: 1, max: 1, frequency: null, restricted: false },
      { id: 24, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 180, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 103, cost: 1, max: 2, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 121, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 137, cost: 1, max: 1, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
      { id: 155, cost: 2, max: 1, frequency: null, restricted: false },
      { id: 173, cost: 1, max: null, frequency: { amount: 1, per: 'Refresh', charge: null }, restricted: false },
    ]
  },
]